import './App.css';
import Hero from "./hero";

function App() {
  return (
    <div className="App">
      <Hero/>
    </div>
  );
}

export default App;
